module.exports = __webpack_public_path__ + "static/media/partitions_gwp_60yd_y.26dbb936.csv";